module.exports = __webpack_public_path__ + "img/img_ghost_13@3x.7c46ca72.png";